/**
 * 展示用图片地址：`menu_image` / `dish_image` 由接口存完整 URL，此处不做路径拼接。
 * 对 http(s) 链接附加缓存破坏参数，避免替换图片后浏览器仍用旧缓存。
 */

/** 组件/API 侧区分菜单图与菜品图（本工具不再用于拼 URL） */
export type RestaurantStaticImageKind = 'menu-image' | 'dish-image';

/**
 * @param imageRef - 实体字段，接口约定为完整可访问 URL；空则返回空串
 */
export function buildRestaurantStaticImageDisplayUrl(imageRef: string | null | undefined): string {
    const raw = (imageRef ?? '').trim();
    const t = Date.now();
    if (!raw) {
        return '';
    }
    if (/^https?:\/\//i.test(raw)) {
        return raw.includes('?') ? `${raw}&t=${t}` : `${raw}?t=${t}`;
    }
    return raw;
}

/**
 * Apifox：`POST .../restaurant-static/menu-image`、`dish-image` 的 **query** 参数 `file_name`（必填）为「实体 id + 图片后缀」，如 `5.jpg`、`4.png`。
 */
export function buildRestaurantStaticUploadQueryFileName(entityNumericId: number, file: File): string {
    const fromName = file.name?.match(/\.([a-zA-Z0-9]+)$/)?.[1]?.toLowerCase();
    let ext = fromName;
    if (!ext) {
        const mime = file.type?.split('/')[1]?.toLowerCase();
        if (mime === 'jpeg' || mime === 'jpg') {
            ext = 'jpg';
        } else if (mime === 'png' || mime === 'gif' || mime === 'webp') {
            ext = mime;
        } else {
            ext = 'jpg';
        }
    }
    if (ext === 'jpeg') {
        ext = 'jpg';
    }
    return `${entityNumericId}.${ext}`;
}

/**
 * 从存库值解析出 DELETE 接口路径所需的 `file_name`（支持完整 URL、以 `/` 开头的路径、纯文件名）。
 */
export function extractFileNameForRestaurantStaticDelete(imageRef: string | null | undefined): string {
    const s = (imageRef ?? '').trim();
    if (!s) {
        return '';
    }
    if (/^https?:\/\//i.test(s)) {
        try {
            const u = new URL(s);
            const segs = u.pathname.split('/').filter(Boolean);
            const last = segs[segs.length - 1];
            return last ? decodeURIComponent(last) : '';
        } catch {
            return '';
        }
    }
    if (s.startsWith('/')) {
        const segs = s.split('/').filter(Boolean);
        const last = segs[segs.length - 1];
        return last ? decodeURIComponent(last) : '';
    }
    return s;
}
